import ReactHtmlParser from 'html-react-parser';
import { t } from "i18next";
import DefaultLayout from "../Layout/DefaultLayout";

const ContactPage = ({ globalEvent, setGlobalEvent, title }) => {
  
  return (
    <>
      <DefaultLayout globalEvent={globalEvent} setGlobalEvent={setGlobalEvent}>
	  {ReactHtmlParser(t("link.contact"))}				
      </DefaultLayout>
	</>
  );
};

export default ContactPage;